import { InjectionToken } from '@angular/core';

export const BASE_PATH = new InjectionToken<string>('AiGatewayApiBasePath');
export const CONFIGURATION_PATH = new InjectionToken<string>('AiGatewayApiConfiguration');
